import { useState } from 'react'
import classNames from 'classnames'

import Image from '../ui/Image/Image'
import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import Card from '../ui/Card/Card'
import HtmlContent from '../ui/HtmlContent/HtmlContent'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { getImageUrl, isArabic } from '../../utils'

import styles from './RupayLayout.module.scss'

function RupayStack({ header, stack = [] }) {
  const { language } = useLanguage()
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(450)
  const [hoverItemIndex, setHoverItemIndex] = useState(-1)
  const onMouseEnter = (index) => {
    setHoverItemIndex(index)
  }
  const onMouseLeave = () => {
    setHoverItemIndex(-1)
  }

  return (
    <Card className={classNames('page-container', styles.stackCardContainer)}>
      <HeaderScrollHandler
        subTitle={header}
        scrollLeft={scrollLeft}
        scrollRight={scrollRight}
        isAtEnd={isAtEnd}
        isAtStart={isAtStart}
        className={styles.headerContainer}
        subTitleClass={styles.stackSubtitle}
      />
      <div className={styles.stacksContainer} ref={scrollRef}>
        {stack.map((item, index) => {
          // let array = item.title.split(' ')
          // const words = []
          // for (let index = 0; index < array.length; index += 2) {
          //   words.push(
          //     `${array[index]} ${array[index + 1] ? array[index + 1] : ''}`
          //   )
          // }

          return (
            <div
              key={'rupaystack' + item?.id}
              className={classNames(styles.stackCard, {
                [styles.arabicStackCard]: isArabic(language?.code),
              })}
              style={{
                backgroundColor:
                  hoverItemIndex === index
                    ? item.backgroundcolor + 'cc'
                    : item.backgroundcolor + '66',
              }}
              onMouseEnter={() => onMouseEnter(index)}
              onMouseLeave={onMouseLeave}
            >
              {hoverItemIndex === index ? (
                <HtmlContent
                  contentClass={classNames(styles.rupayDescription)}
                  content={item?.hovertext}
                />
              ) : (
                <>
                  <Image
                    src={getImageUrl(item.image)}
                    alt={item?.image?.alternativeText}
                  />
                  <div className={styles.wordsContainer}>
                    {/* {words.map((text, ind) => ( */}
                    <span className={styles.titleText}>{item.title}</span>
                    {/* ))} */}
                  </div>
                </>
              )}
            </div>
          )
        })}
      </div>
      <div className={styles.mobileStacksContainer}>
        {stack.map((item) => {
          return (
            <div
              key={'rupaystack' + item?.id}
              className={styles.stackCard}
              style={{
                backgroundColor: item.backgroundcolor + '66',
              }}
            >
              <>
                <Image
                  src={getImageUrl(item.image)}
                  alt={item?.image?.alternativeText}
                />
                <div className={styles.wordsContainer}>
                  <span className={styles.titleText}>{item.title}</span>
                  <HtmlContent
                    contentClass={classNames(styles.rupayDescription)}
                    content={item?.hovertext}
                  />
                </div>
              </>
            </div>
          )
        })}
      </div>
    </Card>
  )
}

export default RupayStack
